// extracted by mini-css-extract-plugin
export default {"container":"FieldLabel_container__QO+R7","required":"FieldLabel_required__CPEE9"};